import type { BotProfileNumberKey } from './types.ts';

export type BotKnobLimit = { min: number; max: number; step: number; integer: boolean };

/** Range, step, and whether a number knob is whole. Migration clamps to these; the UI uses them. */
export const BOT_KNOB_LIMITS: Readonly<Record<BotProfileNumberKey, BotKnobLimit>> = {
  depth: { min: 1, max: 12, step: 1, integer: true },
  temperature: { min: 0, max: 3, step: 0.05, integer: false },
  aimErrorM: { min: 0, max: 15, step: 0.5, integer: false },
  brakeConfidence: { min: 0.5, max: 2, step: 0.05, integer: false },
  // Not whole: the bars solve it to a pace, and a rounded km/h would miss by about 1%.
  speedLimitKmh: { min: 0, max: 150, step: 1, integer: false },
  contactRoots: { min: 0, max: 16, step: 1, integer: true },
  aggression: { min: 0, max: 2, step: 0.05, integer: false },
  blockMaxCostTurns: { min: 0, max: 3, step: 0.05, integer: false },
  blockMinGainTurns: { min: 0, max: 3, step: 0.05, integer: false },
  width: { min: 4, max: 96, step: 1, integer: true },
  density: { min: 8, max: 80, step: 1, integer: true },
  rootDensity: { min: 16, max: 160, step: 1, integer: true },
  verify: { min: 1, max: 24, step: 1, integer: true },
};

export function clampBotKnob(key: BotProfileNumberKey, value: number): number {
  const limit = BOT_KNOB_LIMITS[key];
  const clamped = Math.min(limit.max, Math.max(limit.min, value));
  // Three decimals: enough for any knob, and files stay readable (no 1.8599999999999999).
  return limit.integer ? Math.round(clamped) : Math.round(clamped * 1000) / 1000;
}
